import { createAsyncThunk } from "@reduxjs/toolkit";
import localhost from "apis/localhost";
import createExportThunk from "slices/proposalDashboard/createExportThunk";
import { selectProposalDashboardFilters } from "slices/proposalDashboard/selectors";
import { resolvePeriod } from "utils/reportingPeriod";

const BASE_URL = "/api/proposal-dashboard/widgets/section-status";

export const fetchSectionStatus = createAsyncThunk(
  "sectionStatus/fetch",
  async (_, { getState }) => {
    const filters = selectProposalDashboardFilters(getState());
    const { periodStart, periodEnd } = resolvePeriod(filters);

    const { data } = await localhost.get(BASE_URL, {
      params: { periodStart, periodEnd },
    });
    return data;
  },
);

export const exportSectionStatusCsv = createExportThunk(BASE_URL, "csv", "Section Status.csv");
export const exportSectionStatusPdf = createExportThunk(BASE_URL, "pdf", "Section Status.pdf");
